export default __webpack_public_path__ + "static/media/win.5524305f.svg";